// extracted by mini-css-extract-plugin
export default {"button":"button--MCRQb","has_animation":"has_animation--ZXUFh","adjustment":"adjustment--zuL3v","icon":"icon--i0IOr","fadeSlideUp":"fadeSlideUp--HbYGA"};